<div>
  <form [formGroup]="emailForm" id="emailForm">
    <div class="form-group">
      <label for="email" class="form-label required">E-mail</label>
      <nz-input-group nzSize="large">
        <input nz-input id="email" formControlName="email" placeholder="Informe o e-mail" />
      </nz-input-group>
    </div>
  </form>
  <div class="row mt-4">
    <div class="col-12 d-flex justify-content-end">
      <button nz-button nzType="primary" [disabled]="emailForm.invalid" [nzLoading]="salvando"
        (click)="handleOk()">Cadastrar</button>
      <button nz-button nzType="default" class="ms-2" (click)="handleCancel()">Cancelar</button>
    </div>
  </div>
</div>
